enum DatePeriodDirection {
    AfterToday = 1,
    BeforeToday = 2,
    AfterThisMonth = 3,
    BeforeThisMonth = 4
}

export default DatePeriodDirection;